import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizumenItemComponent } from './wizumen-content/wizumen-item/wizumen-item.component';
import { WizumenGuideComponent } from './wizumen-modal/wizumen-guide.component';
import { WizumenDetailComponent } from './wizumen-modal/wizumen-detail.component';
import { WizumenAdditionalComponent } from './wizumen-modal/wizumen-additional.component';
import { WizumenBoughtProductComponent } from './wizumen-modal/wizumen-bought-product.component';
import { WizumenComponent } from './wizumen-content/wizumen.component';
import { WizumenConfirmedInfoComponent } from './wizumen-content/wizumen-confirmed-info.component';
import { WizumenSliderComponent } from './wizumen-content/wizumen-item/wizumen-slider.component';
import { WizumenProductIconComponent } from './wizumen-content/wizumen-item/wizumen-product-icon.component';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { SliderModule } from '@shopping-angular-components/slider';
import { EvaDropdownModule } from '../eva-dropdown/eva-dropdown.module';
import { WizumenDetailItemComponent } from './wizumen-content/wizumen-detail-dropdown/wizumen-detail-item/wizumen-detail-item.component';
import { CircularProgressBarComponent } from './wizumen-content/wizumen-detail-dropdown/circular-progress-bar/circular-progress-bar.component';
import { IncentiveXsellComponent } from './wizumen-content/wizumen-detail-dropdown/incentive-xsell/incentive-xsell.component';
import { WizumenDetailDropdownComponent } from './wizumen-content/wizumen-detail-dropdown/wizumen-detail-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';
import { SwipeToBuyModal } from './swipe-to-buy-modal/swipe-to-buy-modal.component';
import { SwipeToBuyHeaderModal } from './swipe-to-buy-modal/swipe-to-buy-header-modal.component';
import { WizumenDateCountdown } from './wizumen-content/wizumen-date-countdown/wizumen-date-countdown.component';
import { OffersModule } from '../offers/offers.module';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { WizumenTripPlannerComponent } from './wizumen-content/wizumen-trip-planner/wizumen-trip-planner.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UserLandingsV2Module } from '../user-landings-v2/user-landings-v2.module';
import { WizumenTravelAssistanceComponent } from './wizumen-content/wizumen-travel-assistance/wizumen-travel-assistance.component';
import { WizumenDetailHeaderComponent } from './wizumen-content/wizumen-detail-header/wizumen-detail-header.component';
import { WizumenCollapsedComponent } from './wizumen-content/wizumen-collapsed/wizumen-collapsed.component';
import { IncentiveXsellCouponComponent } from './wizumen-content/wizumen-detail-dropdown/incentive-xsell/incentive-xsell-coupon.component';
import { BreakLinePipe } from 'projects/common/pipes/break-line.pipe';
@NgModule({
  declarations: [
    WizumenComponent,
    WizumenConfirmedInfoComponent,
    WizumenItemComponent,
    WizumenProductIconComponent,
    WizumenSliderComponent,
    WizumenDetailComponent,
    WizumenAdditionalComponent,
    WizumenBoughtProductComponent,
    WizumenGuideComponent,
    WizumenDetailItemComponent,
    CircularProgressBarComponent,
    IncentiveXsellComponent,
    IncentiveXsellCouponComponent,
    WizumenDetailDropdownComponent,
    SwipeToBuyModal,
    SwipeToBuyHeaderModal,
    WizumenDateCountdown,
    WizumenTripPlannerComponent,
    WizumenTravelAssistanceComponent,
    WizumenDetailHeaderComponent,
    WizumenCollapsedComponent,
  ],
  imports: [
    CommonModule,
    EvaButtonModule,
    SliderModule,
    SliderProModule,
    EvaDropdownModule,
    TranslateModule,
    OffersModule,
    UserLandingsV2Module,
    BrowserAnimationsModule
  ],
  exports: [
    WizumenComponent,
    SwipeToBuyModal,
  ],
  providers: [BreakLinePipe]
})
export class WizumenModule { }
